import { Component, OnInit } from '@angular/core';
import { AlertController, NavController } from '@ionic/angular'
import { FormBuilder, Validators } from '@angular/forms';
import { GlobalVars } from '../../../providers/globalVars';
import { Router } from '@angular/router';
import { AuthData } from '../../../providers/auth-data';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.page.html',
  styleUrls: ['./signin.page.scss'],
})

export class SigninPage implements OnInit {

  public loginForm: any;
  public innerWidth: any;
  public innerHeight: any;
  slideOpts:any={zoom:false};

  chkingauth: boolean = true;

  // tips = [
  //   '채널은 누구나 개설할 수 있어요!', 
  //   '내 관심사의 채널을 즐겨찾기해서 새글 알림을 받을 수 있어요', 
  //   '포인트몰에서 끼니도 해결하고 간식도 사먹고!',
  //   '서비스 탭에서는 내 지역의 행사 및 할인정보를 모아서 보여줘요',
  //   '하루 순삭 주의! 심심할땐 What the Fun 채널!',
  //   '궁금한게 있을땐 묻고답하기 채널에 <br/>무엇이든 물어보세요',
  //   '취미 생활을 공유하고 싶을땐 <br/>채널을 만들어 홍보 해보세요!',
  //   '글을 많이 올리면 <br/>내 채널이 많이 노출되요!',
  //   '지역이동, 로드트립, 오일쉐어 구할땐 <br/>함께 가요! 채널에서~',
  //   '한인 업체 할인 이벤트는 <br/>채널앱에서 바로바로 확인하자!',
  //   '즐겨찾는 채널을 꾸욱 눌러 <br/>순서와 이름을 변경할 수 있어요<i>!</i>',
  // ];
  tips = [
    '내가 쓴 쉐어, 구인, 매매 글은 <br/>클릭 한번으로 재등록 가능하다는 사실!',
    '신규회원에게 가입추천을 <br/>받으면 포인트를 드려요! <br/>이..렇게 많이?!',
    '누구나 채널을 개설할수 있어요!',
    '내 채널의 디자인은 내 입맛대로~',
    '즐겨찾는 채널을 꾸욱 눌러 <br/>순서와 이름을 변경할 수 있어요<i>!</i>',
    '좋아하는 주제의 채널을 즐겨찾기해서 <br/>실시간 알림을 받아 보세요~',
    '(소곤소곤) 정성들인 글은 <br/>더 많이 좋아요를 받는대요~',
    '채널러 끼리 연락할땐 <br/>채널앱 메시지로 바~로 가능!',
    '다양한 편집 기능의 글 작성 가능!<br/>글자 수정, 지도, 동영상, 링크 추가 등등',
    '누구나 우리동네의 <br/>할인 및 이벤트를 올릴수 있어요.',
    '등급업 하는 즉시 <br/>50배의 포인트가 팡! 팡!',
    '새로 왔다면 <br/>좋아요 3번만 해도 레벨업~',
    '한인 업체 할인 이벤트는 <br/>채널앱에서 바로바로 확인하자!',
    '포인트몰에서 <br/>끼니도 해결하고 간식도 사먹고!',
    '서비스 탭에서는 우리동네의 <br/>행사 및 할인정보를 모아서 보여줘요. <br/>너~무 편해!',
    '김워홀(남, 23세)<br/>전 매일 아침 간추린 호주뉴스로 하루를 시작해요. <br/>여러분도 채널 고정.',
    '하루 순삭 주의! <br/>심심할땐 What the Fun 채널!',
    '궁금한게 있을땐 묻고답하기 채널에 <br/>무엇이든 물어보세요',
    // '내 글이 좋아요를 받아도 포인트가 쌓이는 것을!',
    // '내 글에 댓글이 달리면 포인트가 쌓이는 것을!',
    // '내 글에 내가 댓글을 작성하면 포인트가 0인것을..',
    // '최근 본 글은 메뉴에 저장되어 있다',
    // '글작성중에 나가도 임시저장이 가능하다',
    // '내 채널의 글 작성 양식을 변경할수 있다',
    // '내가 작성한 글의 반응이 실시간으로 온다',
  ];
  tip:any;

  movePage:any;

  constructor(public fb: FormBuilder,public gv:GlobalVars, public router: Router,
    private navCtrl:NavController,
    private authData:AuthData,
   public alertCtrl:AlertController) { 
    setTimeout(_=> {
      this.chkingauth = false;
    }, 1650);
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.loginForm = fb.group({
        email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
        password: ['', Validators.compose([Validators.minLength(6), Validators.required])]
    })
  }

  /*ionViewWillEnter(){
    
  }*/

  //이하 fcm 테스트후 삭제
/*
  tkchk(){ firebase.database().ref('/userProfile/jP0HZFCrBfdsESULHclCfyeqSnE2/alarm').once('value').then(rst=>{
        rst.forEach(fav=>{
          console.log(fav.key);
          console.log(fav.val());
        })
      }) }
  */
  async testchk(){
    let alertwrong = await this.alertCtrl.create({
    message: 'Please type vaild code.',
    inputs:[{
      name:'code'
    }],
    buttons: [
      {
        text: 'Cancel',
        role: 'cancel'
      },
      {
        text: 'Confirm',
        handler: (data) => {
          if(data.code == 'ch1290')
          {
            this.router.navigate(['/chsignin'])
          }
          else if(data.code == 'LdwP89mWt0tD1IFVjDt')
          {
            this.router.navigate(['/tabs/home'])
          }
          else
          {
            alert('Sorry, you have no permission with the code. Please try again.');
          }
      }
      }]
    })
    //.then(alertwrong=>
    await alertwrong.present();
  }
  
  ngOnInit() {
    this.tip = this.tips[Math.floor(Math.random() * this.tips.length)];
    
    setTimeout(_=>this.router.navigate([''])
    //this.navCtrl.navigateRoot('')
    ,4200);
  }


  gglogin(){
    this.authData.gglogin();
  }
  fblogin(){
    this.authData.fblogin();
  }
  
}
